<div class="modal-header">
  <h3 class="modal-title">{{titleModal}}</h3>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="col row mb-3" *ngIf="firstTitleName">
      <label class="form-label col-12 align-self-center">{{firstTitleName}}</label>
      <div class="col-12">
        <ng-select *ngIf="firstTitleIsSelector" [items]="firstListItem"
                   bindValue="value"
                   bindLabel="label"
                   [searchable]="false"
                   [clearable]="false"
                   placeholder="-- โปรดเลือก --" formControlName="firstId"
                   [ngClass]="{'is-invalid': isFormInvalid('firstId')}">
        </ng-select>

        <input class="form-control" *ngIf="!firstTitleIsSelector" type="text" placeholder="-- โปรดระบุ --" formControlName="firstName"
               [ngClass]="{'is-invalid': isFormInvalid('firstName')}" />
      </div>
    </div>
    <div class="col row mb-3" *ngIf="secondTitleName">
      <label class="form-label col-12 align-self-center">{{secondTitleName}}</label>
      <div class="col-12">
        <ng-select *ngIf="secondTitleIsSelector" [items]="secondListItem"
                   bindValue="value"
                   bindLabel="label"
                   [searchable]="false"
                   [clearable]="false"
                   placeholder="-- โปรดเลือก --" formControlName="secondId"
                   [ngClass]="{'is-invalid': isFormInvalid('secondId')}">
        </ng-select>

        <input class="form-control" *ngIf="!secondTitleIsSelector && !secondTitleIsNumber" type="text" placeholder="-- โปรดระบุ --" formControlName="secondName"
               [ngClass]="{'is-invalid': isFormInvalid('secondName')}" />
        <input class="form-control" *ngIf="!secondTitleIsSelector && secondTitleIsNumber" type="text" pattern="[0-9]*" placeholder="-- โปรดระบุ --" formControlName="secondName"
               [ngClass]="{'is-invalid': isFormInvalid('secondName')}" (keypress)="onlyAllowNumbers($event)" (input)="onInputChange($event)" />
      </div>
    </div>

    <div class="col row mb-3" *ngIf="haveEquipmentCategory">
      <label class="form-label col-12 align-self-center">หมวดครุภัณฑ์</label>
      <div class="col-12">
        <ng-select [items]="itemEquipmentCategoryList" bindValue="id" bindLabel="name"
          [searchable]="false" [clearable]="false" placeholder="-- โปรดเลือก --" formControlName="categoryIdList"
          [multiple]="true"
          [ngClass]="{'is-invalid': isFormInvalid('categoryIdList')}">
        </ng-select>
      </div>
    </div>

    <div class="col row mb-3" *ngIf="haveEquipmentGroup">
      <label class="form-label col-12 align-self-center">กลุ่มครุภัณฑ์</label>
      <div class="col-12">
        <ng-select [items]="itemEquipmentGroupList" bindValue="id" bindLabel="name" [searchable]="false" [clearable]="false" placeholder="-- โปรดเลือก --" formControlName="groupIdList" [multiple]="true" [ngClass]="{'is-invalid': isFormInvalid('categoryIdList')}">
        </ng-select>
      </div>
    </div>

    <div class="col row mb-3" *ngIf="showHexColor">
      <label class="form-label col-12 align-self-center">สี</label>
      <div class="col-12">
        <input class="form-control form-control-color w-100" type="color" id="colorPicker" name="colorPicker" formControlName="hexColor">
      </div>
    </div>
    <!--<div class="col row mb-3">
      <label class="form-label col-12 align-self-center">{{titleName}}:</label>
      <div class="col-12">
        <input class="form-control" *ngIf="!isSelector" type="text" placeholder="-- โปรดระบุ --" formControlName="name"
               [ngClass]="{'is-invalid': isFormInvalid('name')}" />

        <ng-select *ngIf="!haveMainType && !haveGroup && isSelector" [items]="mainArmamentCategory$ | async"
                   bindValue="id"
                   bindLabel="title"
                   [searchable]="false"
                   [clearable]="false"
                   placeholder="-- โปรดเลือก --" formControlName="selectorId"
                   [ngClass]="{'is-invalid': isFormInvalid('selectorId')}">
        </ng-select>

        <ng-select *ngIf="haveMainType && haveGroup && isSelector" [items]="subArmamentCategory$ | async"
                   bindValue="id"
                   bindLabel="title"
                   [searchable]="false"
                   [clearable]="false"
                   placeholder="-- โปรดเลือก --" formControlName="selectorId"
                   [ngClass]="{'is-invalid': isFormInvalid('selectorId')}">
        </ng-select>

      </div>
    </div>-->
    <div class="col row">
      <div class="col-lg-12 col-xs-12">
        <label for="isActive" class="form-label">สถานะการใช้งาน</label>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="isActive" formControlName="status" />
          <label for="isActive" *ngIf="form.get('status')?.value"
                 class="form-check-label">เปิดใช้งาน</label>
          <label for="isActive" *ngIf="!form.get('status')?.value"
                 class="form-check-label">ปิดการใช้งาน</label>
        </div>
      </div>
    </div>

    <div class="col row" *ngIf="showMultiples">
      <div class="col-lg-12 col-xs-12">
        <label for="isMultiple" class="form-label">มีรายการครุภัณฑ์มากกว่า 1 รายการ</label>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="isMultiple" formControlName="multipleValue" />
          <label for="isMultiple" *ngIf="form.get('multipleValue')?.value"
                 class="form-check-label">มี</label>
          <label for="isMultiple" *ngIf="!form.get('multipleValue')?.value"
                 class="form-check-label">ไม่มี</label>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="onSave()">บันทึก</button>
  <button type="button" class="btn btn-danger" (click)="closeModal()">ยกเลิก</button>
</div>
